'use strict';

var unique = require('./unique'); //passes an item through when you see it for the second time.


module.exports = function nonUnique(field) {
  return unique(field, true);
};